import { lazyWithRetry } from 'src/react-app/utilits/lazy-with-retry'

export const StagePlanAsync = lazyWithRetry(() => import('./stage-plan'))
